import { DateTimeProvider } from 'angular-oauth2-oidc';

export class OAuthDateTimeProvider extends DateTimeProvider {
  now(): number {
    return Date.now();
  }

  new(): Date {
    return new Date();
  }
}
